<template>
    <div class="text-center finalSubmitPopup">
        <v-dialog :scrollable="false" width="700" v-model="dialog">
            <template v-slot:activator="{ on }">
                <!-- <v-btn small text color="grey" class="my-3" v-on="on">more details</v-btn> -->
                <div v-if="icon">
                    <v-btn text color="syn_green" v-on="on">
                        <v-icon>mdi-plus-box</v-icon>
                    </v-btn>
                </div>
                <div v-else>
                    <v-btn class="linkHover mt-3" text @click.prevent color="syn_green" v-on="on">SUBMIT</v-btn>
                </div>
                
            </template>

            <v-card class="ma-0 synThinFont text-center" color="syn_blue_veryDark">
                <!-- <v-card-title class="headline grey lighten-2" primary-title>
                    <div class="text-center">
                        <h3>Submitting <span class="synThickFont">{{currentSong.title}}</span> to <span class="synThickFont">{{currentArtist.name}}</span></h3>
                        
                    </div>
                </v-card-title> -->

                <v-card-text class="pt-4">
                    <div class="text-center">
                        <v-avatar size="140" >
                            <img :src="currentArtist.avatar" :alt="currentArtist.name">
                        </v-avatar>
                    </div>
                    <div class="grey--text mt-2 synThickFont synCaption"> {{currentArtist.price}} CREDITS</div>
                </v-card-text>
                <v-card-text class="white--text">
                    <div style="max-width:80%; margin-left:auto; margin-right:auto">
                        <div class="text-center synThickFont" style="font-size:1.2em;">You are about to submit <span class="primary--text">{{currentSong.title}}</span> to <span class="primary--text">{{currentArtist.name}}</span> for a detailed feedback report. This will cost you <span class="primary--text">{{currentArtist.price}} credits</span>.</div>
                        <div class="mt-2 synThickFont " style="font-size:1.2em;">Would you like to <span class="primary--text">proceed</span>?</div>
                        <div class="mt-2 text-center grey--text"><i>Please note that if this is your first submission with this song, you will not be able to edit your comments attached to this specific song anymore. Also, once you have submitted a song for feedback, you will not be able to delete the submission anymore.</i></div>
                        
                    </div>
                </v-card-text>

                <!-- <v-divider></v-divider> -->

                <v-card-actions>
                    <v-btn color="error" class="mb-3 ml-5 synThickFont" text @click="dialog = false">
                        Back
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="currentArtist.active_status"
                        class="primary mb-3 mr-5 linkHover synThickFont" 
                        text 
                        :loading="loading" 
                        @click="getFeedback(currentUser, currentSong, currentArtist)"
                    >
                        Get Feedback
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div @click.prevent class="text-center ma-2">
            <v-snackbar v-model="snackbar" :timeout="timeout" class="synThinFont">
                {{ snackbarText }}
                <v-btn color="red" text @click.prevent="snackbarClick()"> Close </v-btn>
            </v-snackbar>
        </div>
    </div>


</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import fb from '@/fb'
const db = fb.db
const functions = fb.functions
import moment from 'moment'

export default {
    name: "FinalSubmitPopup",
    data() {
        return {
            loading: false,
            dialog: false,
            snackbarText: null,
            timeout: 4000,
            snackbar: false
        }
    },
    props: {
        currentUser: Object,
        currentArtist: Object,
        currentSong: Object,
        icon: Boolean
    },
    methods: {
        snackbarClick() {
            this.snackbar = false
            // this.$router.push({name:'Pricing'})
        },
        getFeedback(user,song,artist) {
            
            this.loading = true
            
            // Only proceed if email is verified
            if (firebase.auth().currentUser.emailVerified){

                // Check if budget is sufficient
                if (parseInt(user.credits) >= parseInt(artist.price)){
                    
                    // update new credit balance
                    // const new_credit_balance = parseInt(user.credits) - parseInt(artist.price)
                    
                    // create submission object
                    const submission = {
                        user_id: user.user_id,
                        user_name: user.username, //new addition
                        
                        song_id: song.id,
                        song_title: song.title,
                        song_genre: song.genre,
                        song_comments: song.comments,
                        song_audioPath: song.audioPath,
                        song_icon: song.icon,
                        
                        artist_id: artist.artist_id,
                        artist_accomplishments: artist.accomplishments,
                        artist_avatarPath: artist.avatarPath,
                        artist_bio: artist.bio,
                        artist_genre: artist.genre,
                        artist_labels: artist.labels,
                        artist_name: artist.name,
                        artist_plays: artist.plays,
                        artist_price: artist.price,
                        artist_pricingOption: artist.pricingOption,
                        artist_yearsExperience: artist.yearsExperience,

                        artist_earning: (artist.price*0.7), //new addition
                        artist_earned: false, //new addition

                        synthfeed_earning: artist.price - (artist.price*0.7),
                        
                        timestamp: Date.now(),
                        returned: false, /////////////// consider removing it!
                        type: 'default', //new addition
                        status: 'open', //new addition
                        earning_id: null //new addition

                    }
                    
                    // let cloudSubmitSong = functions.httpsCallable('submitSong')
                    // cloudSubmitSong(submission).then(() => {
                    //     console.log('sent');
                    //     // reset everything
                    //     this.dialog=false
                    //     this.loading=false
                    //     this.$router.push({name:'Home'})
                    // })
                    // add submission object to DB
                    
                    db.collection('submissions').add(submission).then((docRef) => {
                        const current_submission_id = docRef.id
                        // console.log('sub id:',current_submission_id);

                        // once submission added update credit balance
                        // db.collection('users')
                        // .where('user_id','==',user.user_id)
                        // .get()
                        // .then(snap => { 
                        //     snap.forEach(doc => {
                        //         db.collection('users').doc(doc.id).update({
                        //             credits: new_credit_balance
                        //         }) 
                        //     })
                        // }).then(()=>{
                        let submitSongDeductCredits = functions.httpsCallable('submitSongDeductCredits')
                        submitSongDeductCredits({
                            uid: user.user_id,
                            price: artist.price,
                            current_credits: user.credits
                        }).then(()=> {
                            // send email
                            let sendMail = functions.httpsCallable('sendMail')
                            sendMail({
                                artist_id: submission.artist_id,
                                artist_name: submission.artist_name,
                                artist_earning: submission.artist_earning,
                                
                                customer_user_name: submission.user_name,
                                customer_id: submission.user_id,
                                customer_email: this.currentUser.email,
                                
                                song_id: submission.song_id,
                                song_title: submission.song_title,
                                song_genre: submission.song_genre,
                                song_comments: submission.song_comments,

                                submission_id: current_submission_id,
                                
                                timestamp: submission.timestamp,
                                timestamp_asDate: moment(submission.timestamp).format('lll'),

                                
                                }).then(()=>{
                                // console.log('sent');
                                // reset everything
                                this.dialog=false
                                this.loading=false
                                this.$router.push({name:'Home'})
                            }).catch((err)=>{
                                console.log(err);
                            })
                        })
                    })
                    
                } else {
                    // if budget is not sufficient
                    // console.log("insufficient funds");
                    this.snackbarText = "Insufficient Funds. Please Stock them up."
                    this.snackbar = true 
                    
                    
                    this.loading = false
                    
                }

            }
            else {
                this.snackbarText = "Please verify your email first!"
                this.snackbar = true 
                    
                    
                this.loading = false
                // this.$router.push({name:'Home'})
            }

            
            
            
        }
    }
}
</script>